export default function YoutubeVideo() {
   return (
      <div style={{ position: 'relative', width: '100%', height: 0, paddingBottom: '56.1%' }} >
         <iframe style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}
            src="https://www.youtube.com/embed/Xzc2rZ2SKLo?controls=0"
            title="Leave a Legacy" frameBorder="0" allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen" />
      </div>
   )
}